export const SET_INSTITUTION_REPORT_DATA = 'SET_INSTITUTION_REPORT_DATA';
export const SET_START_DATE = 'SET_START_DATE';
export const SET_END_DATE = 'SET_END_DATE';
